"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ActionSuccessSelected;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgActionSuccessSelected = function SvgActionSuccessSelected(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "icon/action/success/selected"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 20.215L1.695 12.91a1.25 1.25 0 0 1 1.765-1.77L9 16.68l12-12a1.25 1.25 0 0 1 1.765 1.765L9 20.215z",
    fill: "#262626",
    fillRule: "evenodd"
  }));
};

SvgActionSuccessSelected.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

function ActionSuccessSelected(props) {
  var style = props.style;
  return /*#__PURE__*/_react["default"].createElement(SvgActionSuccessSelected, (0, _extends2["default"])({
    viewBox: "0 0 29 29"
  }, props, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      position: "relative",
      left: "1%",
      top: "5%"
    })
  }));
}

ActionSuccessSelected.propTypes = {
  style: _propTypes["default"].objectOf(_propTypes["default"].any)
};
ActionSuccessSelected.defaultProps = {
  style: undefined
};